// extracted by mini-css-extract-plugin
export default {"container":"SupportButton_container__H44+C","needHelp":"SupportButton_needHelp__XuP9G"};